export default __webpack_public_path__ + "55a5091e92dcd8297a30ae40297de7bc.jpg";